import React from "react"

import useCategoryStore from "../../../data/categoryStore"
import useOneGameStore from "../../../data/oneGameStore"
import useTemplateStore from "../../../data/templateStore"

export default function Category() {
    const rounds = useOneGameStore(state => state.rounds)
    const localGame = JSON.parse(localStorage.getItem("smt-game"))
    const subCat = useTemplateStore(state => state.subCat)

    const currentSlide = localGame?.currentSlide

    const currentRound = rounds.find(r => r.slide === currentSlide)?.round
    const categories = useCategoryStore(state => state.categories)
    const category = localGame?.rounds[currentRound - 1]?.category

    return (
        <div className="slide category-slide">
            <h1 className="category-slide-title">
                {category !== ""
                    ? categories.find(c => c.id === category)?.name
                    : "Category"}
            </h1>
            {category !== "" ? (
                categories.find(c => c.id === category)?.name === "Mystery" && (
                    <h2 className="category-slide-subtitle">{subCat}</h2>
                )
            ) : (
                <h2 className="category-slide-subtitle">Not Selected Yet</h2>
            )}
        </div>
    )
}
